import numeral from "numeral";

numeral.locale("se");

export class DecimalCurrencyValueConverter {
  toView(value) {
    if (value === null || value === undefined) return null;
    return numeral(value).format("0.0");
  }

  fromView(value) {
    if (value == 0) return value;
    return numeral(value).value();
  }
}
